import React, { PropTypes } from 'react';
import { compose } from 'recompose';
import { getAppContext } from '../../util/decorators';
import { connect } from 'react-redux';
import loadModal from 'action/loadModal';
import Stars from './Stars';

// Main user feedback component

const showForm = dispatch => {
  dispatch(loadModal('feedback'));
};

export const FeedbackWidgetComponent = props => (
  <div className={props.className}>
    <div className="feedback__widget" onClick={() => showForm(props.dispatch)}>
      <p className="feedback__widget__title">
        {props.app.t('Feedback.widgetTitle')}
      </p>
      <Stars onSelect={() => showForm(props.dispatch)} />
    </div>
  </div>
);

FeedbackWidgetComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,
  app: PropTypes.object.isRequired,
};

export default compose(connect(), getAppContext)(FeedbackWidgetComponent);



// WEBPACK FOOTER //
// ./src/component/Feedback/FeedbackWidget.jsx